export const maskEmail = (email) => {
  if (!email) return "";

  const [username, domain] = email.split("@");
  if (username.length <= 2) return email; // Don't mask if username is too short

  // If username is 3 characters or less, mask only middle character
  if (username.length <= 3) {
    const maskedUsername =
      username.charAt(0) + "*" + username.charAt(username.length - 1);
    return `${maskedUsername}@${domain}`;
  }

  // For longer usernames, mask only 3 characters in the middle
  const maskedUsername =
    username.charAt(0) + username.charAt(1) + "***" + username.slice(5);

  return `${maskedUsername}@${domain}`;
};
